import VueCharts from "vue-chartjs";
import { Bar, Line } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    data: {},
    labels: {},
    yAxisLabel: {
      default: "ค่า",
    },
    xAxisLabel: {
      default: "แท่ง",
    },
  },

  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart(
      {
        datasets: [
          {
            type: "line",
            label: "My First dataset",
            data: this.data,
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,

        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "Month",
              },
              labels: this.labels,
            },
          ],
          yAxes: [
            {
              type: "category",
              position: "left",
              display: true,
              scaleLabel: {
                display: true,
                labelString: "Request State",
              },
              reverse: true,
              labels: ["ความเสี่ยงสูงมาก", "ความเสี่ยงสูงปานกลาง", "ความเสี่ยงสูง", "ความเสี่ยงปานกลาง", "ความเสี่ยงต่ำ"],
              ticks: {
                // Include a dollar sign in the ticks
                callback: function(value, index, values) {
                  return value;
                },
              },
            },
          ],
        },
      }
    );
  },
};
